import ViewModelCore from "./ViewModel";


export default class ProdutosClienteDetalhesViewModel extends ViewModelCore{
    constructor () {
        super();
        this.Cliente = undefined;
        this.Empresa = undefined;
        this.Produto = undefined;
        this.DataUltimoFaturamento = undefined;
        this.DataUltimaVenda = undefined;
        this.PorcentagemIPI = undefined;
        this.ProdutoLinha = undefined;
        this.ProdutoFSC = undefined;
        this.Componentes = undefined;
        this.Medidas = undefined;
        this.Repeticoes = undefined;
        this.CorFrente = undefined;
        this.CorVerso = undefined;
        this.TipoAcabamentoFrente = undefined;
        this.TipoAcabamentoVerso = undefined;
        this.Material = undefined;
        this.CapaExternaGramatura = undefined;
        this.CapaInternaGramatura = undefined;
        this.PapelOndaGramatura = undefined;
        this.Onda = undefined;
        this.Sistema = undefined;
        this.LinhaProducao = undefined;
        this.EmbalagemColetiva = undefined;
        this.Observacao = undefined;
        this.OrcamentoCritica1 = undefined;
        this.OrcamentoCritica2 = undefined;
        this.OrcamentoCritica3 = undefined;
        this.OrcamentoCritica4 = undefined;
        this.OrcamentoCritica5 = undefined;

    }
}